import { GeneralInputProps } from '@/components/GeneralInputs/type';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  FormSelect,
  FormSelectProps,
  SelectProps,
} from '@moneyforward/ap-frontend-components';
import { memo, useMemo } from 'react';
import { FieldValues } from 'react-hook-form';

export type PulldownTypeSelectProps<TFieldValues extends FieldValues> = Omit<
  FormSelectProps<TFieldValues>,
  'selectProps'
> & { selectProps?: SelectProps };

type PulldownTypeSelectInputProps<TFieldValues extends FieldValues> =
  PulldownTypeSelectProps<TFieldValues> & GeneralInputProps;

const InnerPulldownTypeSelect = <TFieldValues extends FieldValues>({
  control,
  inputId,
  rules,
  name,
  placeholder,
  selectProps: _selectProps,
}: PulldownTypeSelectInputProps<TFieldValues>) => {
  const containerRef = useGlobalContainerRef();

  const selectProps: SelectProps = useMemo(
    () => ({
      ..._selectProps,
      selectAll: undefined,
      selectAllLabel: undefined,
      options: _selectProps?.options ?? [],
      mode: 'single',
      onSearchDebounceWait: 600,
      getPopupContainer: containerRef,
      comboBox: true,
      placeholder: placeholder,
    }),
    [containerRef, placeholder, _selectProps]
  );

  return (
    <FormSelect<TFieldValues>
      name={name}
      control={control}
      inputId={inputId}
      selectProps={selectProps}
      rules={rules}
    />
  );
};
InnerPulldownTypeSelect.displayName = 'InnerPulldownTypeSelect';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const PulldownTypeSelect = memo((props) => (
  <InnerPulldownTypeSelect {...props} />
)) as typeof InnerPulldownTypeSelect;
PulldownTypeSelect.displayName = 'PulldownTypeSelect';
